import { IntegrationSourceEnum, getIntegrationSourceEnumDescription } from '@c2b/muven-commons'
import { BrandChannelModel } from './BrandChannelModel'

export class BrandModel {
    id?:string|number = undefined
    idSource?:string = undefined
    name:string = ''
    title:string = ''
    description:string = ''
    keywords:string = ''
    createdAt:Date|string|undefined = undefined
    updatedAt:Date|string|undefined = undefined
    isActive:boolean = false
    allowExport:boolean = false
    modificationSource:IntegrationSourceEnum
    channels: BrandChannelModel[] = []
    loadingListAction: boolean = false

    constructor(c?:Partial<BrandModel>) {
        Object.assign(this, c)

        this._parseChannels()
    }

    hasIdSource():boolean {
        return !!this.idSource
    }

    getIntegrationSourceEnumDescription():string {
        return getIntegrationSourceEnumDescription(this.modificationSource)
    }

    private _parseChannels():void {
        this.channels = this.channels.map((c) => {
            return new BrandChannelModel(c)
        })        
    }
}
